import React from 'react';
import { Link } from 'react-router-dom';
import classes from './listings.module.scss';
import { useParams } from 'react-router-dom';

const Listings = () => {
    let { id } = useParams();
    let boundaries = id.split("-")
    let start = boundaries[0]
    let end = boundaries[1]
    const data = require('../../data/listValues.json')
        return (
            <div className="list-page">
                    <h2 className={classes.heading}>SOLUTIONS {start} - {end}</h2>
                    <div className={classes.About}>
                        <p> This contains list of solutions {start} - {end}  </p>
                    {data['items'].filter(item => item.serial >= start && item.serial <= end)
                        .map(item =>
                        <div className="post-card">
                            <div class="post-content">
                                <h2 className="title">{item.serial}. <Link to={`/solutions/problem/${item.serial}`}>{item.title}</Link></h2>
                                <p className={classes.Desc}>{item.problemDescription}</p>
                            </div>
                        </div>
                    )}
                    </div>
            </div>
        )
    }
export default Listings;